import { type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/common/helpers/utils";
import { inputVariants } from "@/components/ui/input";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>, VariantProps<typeof inputVariants> {
  error?: boolean;
  ref?: React.Ref<HTMLTextAreaElement>;
}

function Textarea({ className, error, variant, ref, ...props }: TextareaProps) {
  return (
    <textarea
      className={cn(
        inputVariants({ variant }),
        "placeholder:text-muted-foreground flex min-h-15 px-3 py-2 text-base md:text-sm",
        error && "ring-error bg-error/5 ring-1",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
}
Textarea.displayName = "Textarea";

export { Textarea };
